// src/ImagesPaymentsTable.jsx
import React, { useEffect, useMemo, useState, useCallback } from "react";
import { db } from "./firebase";
import {
  addDoc,
  arrayUnion,
  collection,
  deleteDoc,
  doc,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
  where,
  limit,
} from "firebase/firestore";
import ExcelJS from 'exceljs';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

// Cloudinary Configuration
const CLOUD_NAME = 'dodw9wq5x';
const UPLOAD_PRESET = 'test12';

// Telegram Bot Configuration
const TELEGRAM_BOT_TOKEN = '7740314167:AAFWbrtDioAM2j9LapVME_EDDz91YPjuaSc';

const styles = `
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body, html {
    margin: 0;
    padding: 0;
  }

  .wrap {
    padding: 24px;
    background: #0b0f17;
    min-height: 100vh;
    color: #e6edf3;
    font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial;
  }

  .titleRow{
    display:flex;
    align-items:flex-end;
    justify-content:space-between;
    gap:12px;
    margin-bottom:14px;
  }

  .h1{
    font-size:18px;
    margin:0;
    font-weight:700;
    letter-spacing:.2px;
  }

  .sub{
    opacity:.75;
    font-size:12px;
    margin-top:6px;
  }

  .panel{
    background: #0f1623;
    border: 1px solid rgba(255,255,255,.06);
    border-radius: 14px;
    overflow:hidden;
    box-shadow: 0 10px 30px rgba(0,0,0,.35);
  }

  .table{
    width:100%;
    border-collapse: collapse;
    table-layout: fixed;
  }

  thead th{
    background:#0c1220;
    color:#c9d1d9;
    font-size:11px;
    text-transform:uppercase;
    letter-spacing:.8px;
    padding:12px 10px;
    border-bottom:1px solid rgba(255,255,255,.06);
    position:sticky;
    top:0;
    z-index:2;
    cursor:pointer;
    user-select:none;
  }

  tbody td{
    padding:12px 10px;
    border-bottom: 1px solid rgba(255,255,255,.05);
    vertical-align: top;
    font-size:12.5px;
    color:#e6edf3;
    overflow:hidden;
    text-overflow: ellipsis;
  }

  tbody tr:hover{
    background: rgba(255,255,255,.03);
  }

  .muted{ opacity:.7; }
  .chip{
    display:inline-flex;
    align-items:center;
    gap:6px;
    padding:6px 10px;
    border-radius:999px;
    font-size:11px;
    border:1px solid rgba(255,255,255,.10);
    background: rgba(255,255,255,.04);
    white-space:nowrap;
  }

  .chipOk{ border-color: rgba(46, 204, 113,.35); color:#c9f7d6; background: rgba(46, 204, 113,.08);}
  .chipNo{ border-color: rgba(241, 196, 15,.35); color:#fff2b8; background: rgba(241, 196, 15,.08);}

  .imgThumb{
    width:58px;
    height:38px;
    border-radius:10px;
    object-fit:cover;
    border:1px solid rgba(255,255,255,.08);
    display:block;
    background:#0b0f17;
  }

  .btn{
    width:100%;
    border:none;
    border-radius:10px;
    padding:10px 10px;
    font-size:12px;
    font-weight:700;
    cursor:pointer;
    margin-bottom:8px;
    transition: .15s ease;
  }
  .btn:disabled{ opacity:.55; cursor:not-allowed; }

  .btnBlue{ background:#2563eb; color:white; }
  .btnBlue:hover{ filter:brightness(1.05); }

  .btnGreen{ background:#22c55e; color:#06110a; }
  .btnGreen:hover{ filter:brightness(1.05); }

  .btnOrange{ background:#f59e0b; color:#1a1204; }
  .btnOrange:hover{ filter:brightness(1.05); }

  .btnGray{ background:#334155; color:#e6edf3; margin:0; }
  .btnGray:hover{ filter:brightness(1.08); }

  .money{
    font-weight:800;
    font-size:13px;
    white-space:nowrap;
  }

  .moneyWarn{ color:#ffd28a; }
  .moneyGood{ color:#86efac; }
  .moneyBad{ color:#ffb4b4; }

  .historyBox{
    max-height: 110px;
    overflow:auto;
    padding-right:6px;
  }

  .historyItem{
    display:flex;
    justify-content:space-between;
    gap:10px;
    padding:7px 0;
    border-bottom:1px dashed rgba(255,255,255,.10);
  }

  .historyItem:last-child{ border-bottom:none; }

  .modalOverlay{
    position:fixed;
    inset:0;
    background: rgba(0,0,0,.55);
    display:flex;
    align-items:center;
    justify-content:center;
    padding:18px;
    z-index:9999;
    backdrop-filter: blur(4px);
  }

  .modal{
    width: 520px;
    max-width: 100%;
    background:#0f1623;
    border:1px solid rgba(255,255,255,.08);
    border-radius:16px;
    box-shadow: 0 12px 40px rgba(0,0,0,.55);
    padding:18px;
  }

  .modalTitle{
    margin:0 0 10px 0;
    font-size:15px;
    font-weight:800;
  }

  .grid2{
    display:grid;
    grid-template-columns: 1fr 1fr;
    gap:10px;
    margin-bottom:12px;
  }

  .field label{
    display:block;
    font-size:12px;
    font-weight:600;
    opacity:.9;
    margin-bottom:8px;
    color:#c9d1d9;
    letter-spacing:0.3px;
  }

  .field input{
    width:100%;
    border-radius:12px;
    border:1px solid rgba(255,255,255,.10);
    background:#0b1220;
    color:#e6edf3;
    padding:12px 16px;
    outline:none;
    font-size:13px;
    transition: all 0.2s ease;
  }

  .field input:focus{
    border-color: rgba(37, 99, 235, 0.5);
    background:#0d1525;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
  }

  .field input:hover:not(:disabled){
    border-color: rgba(255,255,255,.15);
    background:#0d1525;
  }

  .field input:disabled{
    opacity:0.5;
    cursor:not-allowed;
  }

  .field input::placeholder{
    color:rgba(255,255,255,.4);
  }

  .field input[type="file"]{
    position:absolute;
    width:1px;
    height:1px;
    padding:0;
    margin:-1px;
    overflow:hidden;
    clip:rect(0,0,0,0);
    white-space:nowrap;
    border:0;
  }

  .fileInputWrapper{
    position:relative;
    display:inline-block;
    width:100%;
  }

  .fileInputLabel{
    display:flex;
    align-items:center;
    justify-content:center;
    gap:8px;
    padding:12px 20px;
    border-radius:12px;
    border:2px dashed rgba(255,255,255,.2);
    background:rgba(11, 18, 32, 0.6);
    color:#e6edf3;
    font-size:13px;
    font-weight:600;
    cursor:pointer;
    transition: all 0.2s ease;
    text-align:center;
    min-height:48px;
  }

  .fileInputLabel:hover:not(.disabled){
    border-color: rgba(37, 99, 235, 0.5);
    background:rgba(13, 21, 37, 0.7);
    transform:translateY(-1px);
    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15);
  }

  .fileInputLabel:active:not(.disabled){
    transform:translateY(0);
  }

  .fileInputLabel.disabled{
    opacity:0.5;
    cursor:not-allowed;
    border-color:rgba(255,255,255,.1);
  }

  .fileInputIcon{
    font-size:18px;
  }

  .rowBtns{
    display:flex;
    gap:10px;
    margin-top:12px;
  }

  .smallNote{
    font-size:11px;
    opacity:.75;
    margin-top:8px;
    line-height:1.35;
  }

  /* Minimalistic Scrollbar Styles */
  * {
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.15) transparent;
  }

  *::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  *::-webkit-scrollbar-track {
    background: transparent;
  }

  *::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.15);
    border-radius: 4px;
    border: 2px solid transparent;
    background-clip: padding-box;
  }

  *::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 255, 255, 0.25);
  }

  *::-webkit-scrollbar-corner {
    background: transparent;
  }

  .historyBox::-webkit-scrollbar {
    width: 6px;
  }

  .historyBox::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 3px;
  }

  .historyBox::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 255, 255, 0.3);
  }
`;

function toNumberSafe(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

function sumPayments(arr) {
  if (!Array.isArray(arr)) return 0;
  return arr.reduce((s, p) => s + toNumberSafe(p?.amount), 0);
}

function formatUZS(n) {
  try {
    return new Intl.NumberFormat("uz-UZ").format(toNumberSafe(n));
  } catch {
    return String(toNumberSafe(n));
  }
}

function formatDateMaybe(v) {
  if (!v) return "—";
  if (typeof v === "object" && typeof v.toDate === "function") {
    return v.toDate().toLocaleString("uz-UZ");
  }
  const d = new Date(v);
  if (!Number.isNaN(d.getTime())) return d.toLocaleString("uz-UZ");
  return String(v);
}

// Telegram Bot Functions
const sendTelegramMessage = async (message, botToken, chatId) => {
  if (!botToken || !chatId || botToken === 'YOUR_TELEGRAM_BOT_TOKEN') {
    console.warn('Telegram bot token yoki chat ID sozlanmagan');
    return false;
  }

  try {
    const response = await fetch(`https://api.telegram.org/bot${botToken}/sendMessage`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        chat_id: chatId,
        text: message,
        parse_mode: 'HTML'
      })
    });

    const data = await response.json();

    if (data.ok) {
      console.log('Telegram xabari muvaffaqiyatli yuborildi');
      return true;
    } else {
      console.error('Telegram xabarini yuborishda xatolik:', data);
      return false;
    }
  } catch (error) {
    console.error('Telegram xabarini yuborishda xatolik:', error);
    return false;
  }
};

const sendPaymentNotification = async (user, paymentType, amount, totalPaid, debtRemaining, botToken, chatId) => {
  const emoji = paymentType === '083 Forma' ? '📋' : '💰';
  const message = `
${emoji} <b>YANGI TO'LOV AMALGA OSHIRILDI</b>

👤 <b>Foydalanuvchi:</b> ${user.name || 'Noma\'lum'}
📄 <b>To'lov turi:</b> ${paymentType}
💵 <b>To'lov miqdori:</b> ${formatUZS(amount)}
💰 <b>Jami to'langan:</b> ${formatUZS(totalPaid)}
📊 <b>Qolgan qarz:</b> ${formatUZS(debtRemaining)}

⏰ <i>${new Date().toLocaleString('uz-UZ')}</i>
  `;

  return await sendTelegramMessage(message, botToken, chatId);
};

const sendKursPriceSetNotification = async (user, price, botToken, chatId) => {
  const message = `
💰 <b>KURS NARXI BELGILANDI</b>

👤 <b>Foydalanuvchi:</b> ${user.name || 'Noma\'lum'}
💰 <b>Belgilangan narx:</b> ${formatUZS(price)}
⚠️ <b>Eslatma:</b> Bu narx faqat bir marta belgilanishi mumkin

⏰ <i>${new Date().toLocaleString('uz-UZ')}</i>
  `;

  return await sendTelegramMessage(message, botToken, chatId);
};

const sendForma083PriceSetNotification = async (user, price, botToken, chatId) => {
  const message = `
📋 <b>083 FORMA NARXI BELGILANDI</b>

👤 <b>Foydalanuvchi:</b> ${user.name || 'Noma\'lum'}
💰 <b>Belgilangan narx:</b> ${formatUZS(price)}
⚠️ <b>Eslatma:</b> Bu narx faqat bir marta belgilanishi mumkin

⏰ <i>${new Date().toLocaleString('uz-UZ')}</i>
  `;

  return await sendTelegramMessage(message, botToken, chatId);
};

// Helper function to get admin's Telegram chat ID from Firestore
const getAdminTelegramChatId = async () => {
  try {
    const currentUserEmail = localStorage.getItem('userEmail') || '';
    if (!currentUserEmail) return null;

    const adminsSnapshot = await getDocs(collection(db, 'newadmins'));
    let telegramChatId = null;
    
    adminsSnapshot.forEach((doc) => {
      const adminData = doc.data();
      if (adminData.email === currentUserEmail.toLowerCase().trim()) {
        telegramChatId = adminData.telegramChatId || null;
      }
    });

    return telegramChatId;
  } catch (error) {
    console.error('Error fetching admin Telegram chat ID:', error);
    return null;
  }
};

export default function ImagesPaymentsTable({ adminLocation, userRole, onLogout, hideHeader = false }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [showAllUsers, setShowAllUsers] = useState(false);
  const [allRows, setAllRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [searchPassportId, setSearchPassportId] = useState("");
  const [searchName, setSearchName] = useState("");

  const [sort, setSort] = useState({ key: "uploadedAt", dir: "desc" });

  const [modal, setModal] = useState({
    open: false,
    type: null, // "kursPay" | "forma083Pay" | "forma083Set" | "kursSet" | "createUser"
    row: null,
  });

  const [amountInput, setAmountInput] = useState("");
  const [newUserForm, setNewUserForm] = useState({
    name: "",
    phone: "",
    passportId: "",
    location: "",
    photo: "",
    comment: "",
  });
  const [uploadingPhoto, setUploadingPhoto] = useState(false);

  const fetchRows = useCallback(async (loadAll = false) => {
    setLoading(true);
    setErr("");
    try {
      // Get admin location from prop or localStorage (with fallback to Firestore)
      let location = adminLocation || localStorage.getItem('adminLocation') || '';
      const isSuperAdmin = userRole === 'superadmin' || localStorage.getItem('userRole') === 'superadmin';
      
      // If location is not found and user is not superadmin, try to fetch from Firestore
      if (!location && !isSuperAdmin) {
        try {
          const currentUserEmail = localStorage.getItem('userEmail') || '';
          if (currentUserEmail) {
            const adminsSnapshot = await getDocs(collection(db, 'newadmins'));
            adminsSnapshot.forEach((doc) => {
              const adminData = doc.data();
              if (adminData.email === currentUserEmail.toLowerCase().trim()) {
                location = adminData.location || '';
                if (location) {
                  localStorage.setItem('adminLocation', location);
                  console.log('✅ Admin location fetched from Firestore:', location);
                }
              }
            });
          }
        } catch (err) {
          console.warn('Could not fetch admin location from Firestore:', err);
        }
      }
      
      // Normalize admin location once
      const adminLocationNormalized = location ? location.toString().toLowerCase().trim() : '';
      
      // Fetch all documents (no limit) to get all users for the location
      // We'll paginate the results on the client side to reduce rendering pressure
      const q = query(collection(db, "images"), orderBy("uploadedAt", "desc"));
      
      const snap = await getDocs(q);
      const list = [];
      
      snap.forEach((d) => {
        const rowData = d.data();
        
        // Filter by location if admin is not superadmin and location is set
        if (!isSuperAdmin && adminLocationNormalized) {
          const userLocationRaw = rowData.location || '';
          const userLocationNormalized = userLocationRaw.toString().toLowerCase().trim();
          
          // Only include rows that match the admin's location exactly
          if (userLocationNormalized !== adminLocationNormalized) {
            return; // Skip this row - location doesn't match
          }
        }
        
        list.push({ id: d.id, ...rowData });
      });
      
      // Store all fetched rows
      setAllRows(list);
      
      // If not loading all, use pagination
      if (!loadAll) {
        setShowAllUsers(false);
        // Reset to page 1 if we're fetching fresh data
        setCurrentPage(1);
        // Show first page (10 items)
        const startIndex = 0;
        const endIndex = itemsPerPage;
        setRows(list.slice(startIndex, endIndex));
      } else {
        setRows(list);
        setShowAllUsers(true);
        setCurrentPage(1);
      }
    } catch (e) {
      console.error('Error fetching rows:', e);
      
      // Handle specific error codes
      let errorMessage = "Firestore dan ma'lumot yuklashda xatolik.";
      
      if (e.code === 'unavailable') {
        errorMessage = "Internet aloqasi yo'q yoki zaif. Iltimos, internet aloqasini tekshiring.";
      } else if (e.code === 'permission-denied') {
        errorMessage = "Ruxsat rad etildi. Firestore xavfsizlik qoidalarini tekshiring.";
      } else if (e.message) {
        errorMessage = e.message;
      }
      
      setErr(errorMessage);
    } finally {
      setLoading(false);
    }
  }, [adminLocation, userRole]);


  // Pagination functions
  const goToPage = (page) => {
    if (showAllUsers) return; // No pagination when showing all
    
    const totalPages = Math.ceil(allRows.length / itemsPerPage);
    if (page < 1 || page > totalPages) return;
    
    setCurrentPage(page);
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setRows(allRows.slice(startIndex, endIndex));
  };

  const nextPage = () => {
    goToPage(currentPage + 1);
  };

  const prevPage = () => {
    goToPage(currentPage - 1);
  };

  // Update rows when currentPage changes (for when allRows updates)
  useEffect(() => {
    if (!showAllUsers && allRows.length > 0 && currentPage > 0) {
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      setRows(allRows.slice(startIndex, endIndex));
    }
  }, [currentPage, allRows, showAllUsers, itemsPerPage]);

  useEffect(() => {
    fetchRows(false); // Load only 10 initially
  }, [fetchRows]); // Refetch when fetchRows changes

  const sorted = useMemo(() => {
    const copy = [...rows];
    const { key, dir } = sort;
    copy.sort((a, b) => {
      const av = a?.[key];
      const bv = b?.[key];

      const aNum = typeof av === "number" ? av : NaN;
      const bNum = typeof bv === "number" ? bv : NaN;

      const aTime =
        av && typeof av === "object" && typeof av.toDate === "function"
          ? av.toDate().getTime()
          : typeof av === "string"
          ? new Date(av).getTime()
          : NaN;

      const bTime =
        bv && typeof bv === "object" && typeof bv.toDate === "function"
          ? bv.toDate().getTime()
          : typeof bv === "string"
          ? new Date(bv).getTime()
          : NaN;

      let res = 0;
      if (!Number.isNaN(aNum) && !Number.isNaN(bNum)) res = aNum - bNum;
      else if (!Number.isNaN(aTime) && !Number.isNaN(bTime)) res = aTime - bTime;
      else res = String(av ?? "").localeCompare(String(bv ?? ""));

      return dir === "asc" ? res : -res;
    });
    return copy;
  }, [rows, sort]);

  const toggleSort = (key) => {
    setSort((p) => ({
      key,
      dir: p.key === key && p.dir === "asc" ? "desc" : "asc",
    }));
  };

  const openModal = (type, row) => {
    setModal({ open: true, type, row });
    setAmountInput("");
    if (type === "createUser") {
      // Get admin location for new user - try multiple sources
      let location = adminLocation || localStorage.getItem('adminLocation') || '';
      
      // If still no location and not superadmin, try to fetch from Firestore
      if (!location) {
        const isSuperAdmin = userRole === 'superadmin' || localStorage.getItem('userRole') === 'superadmin';
        if (!isSuperAdmin) {
          // Note: We can't do async here, so we'll rely on the createNewUser function to handle it
          console.log('No location found, will try to fetch in createNewUser');
        }
      }
      
      setNewUserForm({
        name: "",
        phone: "",
        passportId: "",
        location: location
      });
      
      console.log('Opening create user modal with location:', location);
    }
  };

  const closeModal = () => {
    setModal({ open: false, type: null, row: null });
    setNewUserForm({ name: "", phone: "", passportId: "", location: "", photo: "", comment: "" });
    setUploadingPhoto(false);
  };

  // Handle photo upload to Cloudinary
  const handlePhotoUpload = async (file) => {
    setUploadingPhoto(true);
    setErr("");
    try {
      const uploadData = new FormData();
      uploadData.append('file', file);
      uploadData.append('upload_preset', UPLOAD_PRESET);
      uploadData.append('cloud_name', CLOUD_NAME);

      console.log('Uploading to Cloudinary with preset:', UPLOAD_PRESET);

      const response = await fetch(
        `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
        {
          method: 'POST',
          body: uploadData,
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error?.message || `Upload failed with status ${response.status}`);
      }

      console.log('Upload successful:', data);
      setNewUserForm(prev => ({
        ...prev,
        photo: data.secure_url
      }));
    } catch (error) {
      console.error('Cloudinary upload error:', error);
      setErr(`Rasm yuklashda xatolik: ${error.message}`);
      alert(`Rasm yuklashda xatolik: ${error.message}`);
    } finally {
      setUploadingPhoto(false);
    }
  };

  // Handle file input change
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        alert('Iltimos, rasm faylini tanlang (JPEG, PNG, va hokazo).');
        return;
      }

      if (file.size > 5 * 1024 * 1024) {
        alert('Rasm hajmi 5MB dan kichik bo\'lishi kerak.');
        return;
      }

      handlePhotoUpload(file);
    }
  };

  const parseAmount = (v) => {
    const raw = String(v).replace(/\s/g, "");
    const n = Number(raw);
    return Number.isFinite(n) ? n : 0;
  };

  const saveKursPriceOnce = async () => {
    const row = modal.row;
    const price = parseAmount(amountInput);
    if (!row) return;

    if (!price || price <= 0) {
      alert("Kurs narxini to'g'ri kiriting.");
      return;
    }
    if (row.agreedAmount && row.agreedAmount > 0) {
      alert("Kurs narxi allaqachon belgilangan.");
      return;
    }

    try {
      setLoading(true);
      const ref = doc(db, "images", row.id);
      await updateDoc(ref, {
        agreedAmount: price,
        kursPriceSetAt: serverTimestamp(),
      });

      // Send Telegram notification
      const botToken = localStorage.getItem('telegramBotToken') || TELEGRAM_BOT_TOKEN;
      const chatId = await getAdminTelegramChatId();
      if (botToken && chatId && botToken !== 'YOUR_TELEGRAM_BOT_TOKEN') {
        await sendKursPriceSetNotification(row, price, botToken, chatId);
      }

      await fetchRows(showAllUsers);
      closeModal();
    } catch (e) {
      console.error(e);
      alert("Kurs narxini belgilashda xatolik.");
    } finally {
      setLoading(false);
    }
  };

  const saveForma083PriceOnce = async () => {
    const row = modal.row;
    const price = parseAmount(amountInput);
    if (!row) return;

    if (!price || price <= 0) {
      alert("083 narxini to'g'ri kiriting.");
      return;
    }
    if (row.agreedAmountForma083 !== null && row.agreedAmountForma083 !== undefined) {
      alert("083 narxi allaqachon belgilangan.");
      return;
    }

    try {
      setLoading(true);
      const ref = doc(db, "images", row.id);
      await updateDoc(ref, {
        agreedAmountForma083: price,
        forma083PriceSetAt: serverTimestamp(),
      });

      // Send Telegram notification
      const botToken = localStorage.getItem('telegramBotToken') || TELEGRAM_BOT_TOKEN;
      const chatId = await getAdminTelegramChatId();
      if (botToken && chatId && botToken !== 'YOUR_TELEGRAM_BOT_TOKEN') {
        await sendForma083PriceSetNotification(row, price, botToken, chatId);
      }

      await fetchRows(showAllUsers);
      closeModal();
    } catch (e) {
      console.error(e);
      alert("083 narxini belgilashda xatolik.");
    } finally {
      setLoading(false);
    }
  };

  const createNewUser = async () => {
    if (!newUserForm.name || !newUserForm.phone || !newUserForm.passportId) {
      alert("Iltimos, barcha maydonlarni to'ldiring (Ism, Telefon, Pasport ID).");
      return;
    }

    // Simple rate limit: 1 user per minute per browser
    const lastCreatedAt = localStorage.getItem('lastUserCreatedAt');
    if (lastCreatedAt) {
      const diffMs = Date.now() - Number(lastCreatedAt);
      const oneMinuteMs = 60 * 1000;
      if (diffMs < oneMinuteMs) {
        const remainingSec = Math.ceil((oneMinuteMs - diffMs) / 1000);
        alert(`Siz bir daqiqada faqat 1 ta foydalanuvchi yarata olasiz. Iltimos, ${remainingSec} soniya kuting.`);
        return;
      }
    }

    try {
      setLoading(true);
      setErr("");
      
      // Get location from form, prop, or localStorage
      let location = newUserForm.location || adminLocation || localStorage.getItem('adminLocation') || '';
      
      // If location is still not found and user is not superadmin, try to fetch from Firestore
      if (!location) {
        const isSuperAdmin = userRole === 'superadmin' || localStorage.getItem('userRole') === 'superadmin';
        if (!isSuperAdmin) {
          try {
            const currentUserEmail = localStorage.getItem('userEmail') || '';
            if (currentUserEmail) {
              const adminsSnapshot = await getDocs(collection(db, 'newadmins'));
              adminsSnapshot.forEach((doc) => {
                const adminData = doc.data();
                if (adminData.email === currentUserEmail.toLowerCase().trim()) {
                  location = adminData.location || '';
                  if (location) {
                    localStorage.setItem('adminLocation', location);
                    console.log('✅ Admin location fetched from Firestore:', location);
                  }
                }
              });
            }
          } catch (err) {
            console.warn('Could not fetch admin location from Firestore:', err);
          }
        }
      }
      
      if (!location) {
        alert("Xatolik: Admin lokatsiyasi topilmadi. Iltimos, qayta kirib ko'ring.");
        setLoading(false);
        return;
      }

      console.log('Creating new user with data:', {
        name: newUserForm.name.trim(),
        phone: newUserForm.phone.trim(),
        passportId: newUserForm.passportId.trim(),
        location: location
      });

      const newUserData = {
        name: newUserForm.name.trim(),
        phone: newUserForm.phone.trim(),
        passportId: newUserForm.passportId.trim(),
        location: location,
        comment: (newUserForm.comment || '').trim(),
        agreedAmount: 0,
        agreedAmountForma083: null,
        debtPayments: [],
        forma083Payments: [],
        tugatganligi: false,
        uploadedAt: serverTimestamp(),
        imageUrl: newUserForm.photo || "",
        category: "N/A"
      };

      const docRef = await addDoc(collection(db, "images"), newUserData);
      console.log('User created successfully with ID:', docRef.id);

      await fetchRows(showAllUsers);
      closeModal();
      localStorage.setItem('lastUserCreatedAt', Date.now().toString());
      alert("Foydalanuvchi muvaffaqiyatli yaratildi!");
    } catch (e) {
      console.error('Error creating user:', e);
      
      // Handle specific error codes
      let errorMessage = "Noma'lum xatolik";
      
      if (e.code === 'unavailable') {
        errorMessage = "Internet aloqasi yo'q yoki zaif. Iltimos, internet aloqasini tekshiring va qayta urinib ko'ring.";
      } else if (e.code === 'permission-denied') {
        errorMessage = "Ruxsat rad etildi. Firestore xavfsizlik qoidalarini tekshiring.";
      } else if (e.code === 'failed-precondition') {
        errorMessage = "Operatsiya bajarilishi mumkin emas. Iltimos, qayta urinib ko'ring.";
      } else if (e.message) {
        errorMessage = e.message;
      } else if (e.code) {
        errorMessage = `Xatolik kodi: ${e.code}`;
      }
      
      alert(`Foydalanuvchi yaratishda xatolik: ${errorMessage}`);
      setErr(`Xatolik: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  };

  // Export to Excel (currently unused - can be added to UI if needed)
  // eslint-disable-next-line no-unused-vars
  const exportToExcel = async () => {
    try {
      setLoading(true);
      
      // Create workbook and worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('To\'lovlar');

      // Define headers (including image column)
      const headers = [
        'Rasm',
        'Ism',
        'Telefon',
        'Pasport ID',
        'Lokatsiya',
        'Tugatganligi',
        'Kurs kelishilgan summa',
        'Kurs to\'langan',
        'Kurs qoldiq',
        '083 kelishilgan summa',
        '083 to\'langan',
        '083 qoldiq',
        'Ro\'yxatdagi sana',
        'Kurs to\'lovlar soni',
        '083 to\'lovlar soni',
      ];

      // Add header row
      worksheet.addRow(headers);

      // Style header row
      const headerRow = worksheet.getRow(1);
      headerRow.font = { bold: true, color: { argb: 'FFFFFFFF' } };
      headerRow.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF0F172A' }
      };
      headerRow.alignment = { vertical: 'middle', horizontal: 'center' };
      headerRow.height = 25;

      // Set column widths
      worksheet.getColumn(1).width = 15; // Rasm
      worksheet.getColumn(2).width = 25; // Ism
      worksheet.getColumn(3).width = 15; // Telefon
      worksheet.getColumn(4).width = 15; // Pasport ID
      worksheet.getColumn(5).width = 15; // Lokatsiya
      worksheet.getColumn(6).width = 15; // Tugatganligi
      worksheet.getColumn(7).width = 20; // Kurs kelishilgan summa
      worksheet.getColumn(8).width = 18; // Kurs to'langan
      worksheet.getColumn(9).width = 18; // Kurs qoldiq
      worksheet.getColumn(10).width = 22; // 083 kelishilgan summa
      worksheet.getColumn(11).width = 18; // 083 to'langan
      worksheet.getColumn(12).width = 18; // 083 qoldiq
      worksheet.getColumn(13).width = 20; // Ro'yxatdagi sana
      worksheet.getColumn(14).width = 18; // Kurs to'lovlar soni
      worksheet.getColumn(15).width = 18; // 083 to'lovlar soni

      // Set row height for image rows
      const imageRowHeight = 80;

      // Process each row
      for (let i = 0; i < sorted.length; i++) {
        const r = sorted[i];
        const kursAgreed = toNumberSafe(r.agreedAmount);
        const kursPaid = sumPayments(r.debtPayments);
        const kursRemain = kursAgreed - kursPaid;

        const f083Agreed =
          r.agreedAmountForma083 === null || r.agreedAmountForma083 === undefined
            ? null
            : toNumberSafe(r.agreedAmountForma083);
        const f083Paid = sumPayments(r.forma083Payments);
        const f083Remain = f083Agreed === null ? null : f083Agreed - f083Paid;

        // Prepare row data (image will be added separately)
        const rowData = [
          '', // Placeholder for image
          r.name || '—',
          r.phone || '—',
          r.passportId || '—',
          r.location || '—',
          r.tugatganligi ? 'Tugatgan' : 'Jarayonda',
          formatUZS(kursAgreed),
          formatUZS(kursPaid),
          formatUZS(Math.max(0, kursRemain)),
          f083Agreed === null ? 'Belgilanmagan' : formatUZS(f083Agreed),
          formatUZS(f083Paid),
          f083Remain === null ? '—' : formatUZS(Math.max(0, f083Remain)),
          formatDateMaybe(r.uploadedAt),
          (r.debtPayments || []).length,
          (r.forma083Payments || []).length,
        ];

        const row = worksheet.addRow(rowData);
        row.height = imageRowHeight;

        // Add image if available
        if (r.imageUrl && r.imageUrl.trim() !== '') {
          try {
            // Fetch image
            const response = await fetch(r.imageUrl);
            const imageBuffer = await response.arrayBuffer();
            
            // Determine image type from Content-Type header or URL
            const contentType = response.headers.get('content-type') || '';
            let extension = 'jpeg'; // default
            if (contentType.includes('png') || r.imageUrl.toLowerCase().includes('.png')) {
              extension = 'png';
            } else if (contentType.includes('jpeg') || contentType.includes('jpg') || r.imageUrl.toLowerCase().includes('.jpg') || r.imageUrl.toLowerCase().includes('.jpeg')) {
              extension = 'jpeg';
            }
            
            // Add image to worksheet
            const imageId = workbook.addImage({
              buffer: imageBuffer,
              extension: extension,
            });

            // Insert image in first column (column A, which is index 1)
            worksheet.addImage(imageId, {
              tl: { col: 0, row: i + 1 }, // Top-left position (0-indexed, +1 for header)
              ext: { width: 60, height: 60 }, // Image size
            });
          } catch (imgError) {
            console.error('Error loading image for row:', r.name, imgError);
            // Continue without image if there's an error
          }
        }

        // Center align all cells except image
        row.eachCell({ includeEmpty: false }, (cell, colNumber) => {
          if (colNumber !== 1) { // Skip image column
            cell.alignment = { vertical: 'middle', horizontal: 'center' };
          }
        });
      }

      // Generate filename with current date
      const dateStr = new Date().toISOString().split('T')[0];
      const filename = `tolovlar_${dateStr}.xlsx`;

      // Save file
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.click();
      window.URL.revokeObjectURL(url);

      setLoading(false);
      alert(`Excel fayl muvaffaqiyatli yuklandi: ${filename}`);
    } catch (error) {
      console.error('Excel export error:', error);
      setLoading(false);
      alert('Excel faylni yuklashda xatolik yuz berdi.');
    }
  };

  // Export to PDF (currently unused - can be added to UI if needed)
  // eslint-disable-next-line no-unused-vars
  const exportToPDF = () => {
    try {
      const doc = new jsPDF('landscape', 'mm', 'a4');
      
      // Add title
      doc.setFontSize(16);
      doc.text('To\'lovlar boshqaruvi', 14, 15);
      
      // Add date
      doc.setFontSize(10);
      const currentDate = new Date().toLocaleString('uz-UZ');
      doc.text(`Sana: ${currentDate}`, 14, 22);
      doc.text(`Jami yozuvlar: ${sorted.length}`, 14, 27);

      // Prepare table data
      const tableData = sorted.map((r) => {
        const kursAgreed = toNumberSafe(r.agreedAmount);
        const kursPaid = sumPayments(r.debtPayments);
        const kursRemain = kursAgreed - kursPaid;

        const f083Agreed =
          r.agreedAmountForma083 === null || r.agreedAmountForma083 === undefined
            ? null
            : toNumberSafe(r.agreedAmountForma083);
        const f083Paid = sumPayments(r.forma083Payments);
        const f083Remain = f083Agreed === null ? null : f083Agreed - f083Paid;

        return [
          r.name || '—',
          r.phone || '—',
          r.passportId || '—',
          r.location || '—',
          r.tugatganligi ? 'Tugatgan' : 'Jarayonda',
          formatUZS(kursAgreed),
          formatUZS(kursPaid),
          formatUZS(Math.max(0, kursRemain)),
          f083Agreed === null ? 'Belgilanmagan' : formatUZS(f083Agreed),
          formatUZS(f083Paid),
          f083Remain === null ? '—' : formatUZS(Math.max(0, f083Remain)),
          formatDateMaybe(r.uploadedAt),
        ];
      });

      // Add table
      doc.autoTable({
        head: [['Ism', 'Telefon', 'Pasport ID', 'Lokatsiya', 'Tugatganligi', 'Kurs kelishilgan', 'Kurs to\'langan', 'Kurs qoldiq', '083 kelishilgan', '083 to\'langan', '083 qoldiq', 'Sana']],
        body: tableData,
        startY: 32,
        styles: { fontSize: 7, cellPadding: 1.5 },
        headStyles: { fillColor: [15, 23, 42], textColor: [255, 255, 255], fontStyle: 'bold' },
        alternateRowStyles: { fillColor: [15, 23, 42] },
        margin: { top: 32 },
        tableWidth: 'wrap',
      });

      // Generate filename with current date
      const dateStr = new Date().toISOString().split('T')[0];
      const filename = `tolovlar_${dateStr}.pdf`;

      // Save file
      doc.save(filename);
      alert(`PDF fayl muvaffaqiyatli yuklandi: ${filename}`);
    } catch (error) {
      console.error('PDF export error:', error);
      alert('PDF faylni yuklashda xatolik yuz berdi.');
    }
  };

  const addPayment = async (paymentKey) => {
    // paymentKey: "debtPayments" | "forma083Payments"
    const row = modal.row;
    const amount = parseAmount(amountInput);
    if (!row) return;

    if (!amount || amount <= 0) {
      alert("To'lov miqdorini to'g'ri kiriting.");
      return;
    }

    const agreed =
      paymentKey === "debtPayments"
        ? toNumberSafe(row.agreedAmount)
        : toNumberSafe(row.agreedAmountForma083);

    if (!agreed) {
      alert("Kelishilgan summa topilmadi.");
      return;
    }

    const paidSoFar =
      paymentKey === "debtPayments"
        ? sumPayments(row.debtPayments)
        : sumPayments(row.forma083Payments);

    const remain = agreed - paidSoFar;

    if (amount > remain) {
      alert("To'lov miqdori qolgan qarzdan katta bo'lishi mumkin emas.");
      return;
    }

    try {
      setLoading(true);
      const ref = doc(db, "images", row.id);
      const record = { amount, timestamp: new Date().toISOString() };

      await updateDoc(ref, {
        [paymentKey]: arrayUnion(record),
        lastPaymentAt: serverTimestamp(),
      });

      // Calculate new values for notification
      const newTotalPaid = paidSoFar + amount;
      const newDebtRemaining = agreed - newTotalPaid;
      const paymentType = paymentKey === "debtPayments" ? "Kurs to'lovi" : "083 Forma";

      // Send Telegram notification
      const botToken = localStorage.getItem('telegramBotToken') || TELEGRAM_BOT_TOKEN;
      const chatId = await getAdminTelegramChatId();
      if (botToken && chatId && botToken !== 'YOUR_TELEGRAM_BOT_TOKEN') {
        await sendPaymentNotification(row, paymentType, amount, newTotalPaid, newDebtRemaining, botToken, chatId);
      }

      await fetchRows(showAllUsers);
      closeModal();
    } catch (e) {
      console.error(e);
      alert("To'lovni saqlashda xatolik.");
    } finally {
      setLoading(false);
    }
  };

  // Mark course as completed
  const markKursCompleted = async (row) => {
    if (!row || row.tugatganligi) return;
    if (!window.confirm(`"${row.name || 'Foydalanuvchi'}" uchun kursni tamomlangan deb belgilamoqchimisiz?`)) {
      return;
    }
    try {
      setLoading(true);
      const ref = doc(db, "images", row.id);
      await updateDoc(ref, {
        tugatganligi: true,
      });
      await fetchRows(showAllUsers);
    } catch (e) {
      console.error('Error marking course completed:', e);
      alert("Kurs holatini yangilashda xatolik yuz berdi.");
    } finally {
      setLoading(false);
    }
  };

  // Delete user (superadmin only)
  const handleDeleteUser = async (row) => {
    if (!row) return;
    if (!window.confirm(`"${row.name || 'Foydalanuvchi'}" ni o'chirmoqchimisiz? Bu amalni qaytarib bo'lmaydi.`)) {
      return;
    }
    try {
      setLoading(true);
      await deleteDoc(doc(db, "images", row.id));
      await fetchRows(showAllUsers);
      setErr("");
    } catch (e) {
      console.error('Error deleting user:', e);
      alert("Foydalanuvchini o'chirishda xatolik yuz berdi.");
    } finally {
      setLoading(false);
    }
  };

  // Search by passport ID - fetches only 1 doc from Firebase (no pressure on server)
  // For admin: verifies user belongs to admin's location after fetching
  const handleSearchByPassport = async () => {
    const term = searchPassportId.trim().toUpperCase();
    if (!term) {
      fetchRows(false);
      return;
    }

    setLoading(true);
    setErr("");
    try {
      let location = adminLocation || localStorage.getItem('adminLocation') || '';
      const isSuperAdmin = userRole === 'superadmin' || localStorage.getItem('userRole') === 'superadmin';

      // Fetch admin location if missing (non-superadmin)
      if (!location && !isSuperAdmin) {
        const currentUserEmail = localStorage.getItem('userEmail') || '';
        if (currentUserEmail) {
          const adminsSnapshot = await getDocs(collection(db, 'newadmins'));
          adminsSnapshot.forEach((d) => {
            const adminData = d.data();
            if (adminData.email === currentUserEmail.toLowerCase().trim()) {
              location = adminData.location || '';
              if (location) localStorage.setItem('adminLocation', location);
            }
          });
        }
      }

      // Query ONLY by passportId - fetches max 1 doc (no composite index, no load)
      const q = query(
        collection(db, "images"),
        where("passportId", "==", term),
        limit(1)
      );
      const snap = await getDocs(q);

      const list = [];
      snap.forEach((d) => {
        const rowData = d.data();
        // For non-superadmin: only show if user is in admin's location
        if (!isSuperAdmin && location) {
          const userLoc = (rowData.location || '').toString().toLowerCase().trim();
          const adminLoc = location.toString().toLowerCase().trim();
          if (userLoc !== adminLoc) return; // skip - wrong location
        }
        list.push({ id: d.id, ...rowData });
      });

      setAllRows(list);
      setRows(list);
      setShowAllUsers(true);
      setCurrentPage(1);

      if (list.length === 0) {
        setErr("Berilgan pasport ID bo'yicha foydalanuvchi topilmadi.");
      }
    } catch (e) {
      console.error('Error searching user by passport:', e);
      setErr("Qidiruvda xatolik yuz berdi. Iltimos, keyinroq qayta urinib ko'ring.");
    } finally {
      setLoading(false);
    }
  };

  const handleSearchByName = async () => {
    const term = searchName.trim();
    if (!term) {
      fetchRows(false);
      return;
    }

    setLoading(true);
    setErr("");
    try {
      let location = adminLocation || localStorage.getItem('adminLocation') || '';
      const isSuperAdmin = userRole === 'superadmin' || localStorage.getItem('userRole') === 'superadmin';

      // Fetch admin location if missing (non-superadmin)
      if (!location && !isSuperAdmin) {
        const currentUserEmail = localStorage.getItem('userEmail') || '';
        if (currentUserEmail) {
          const adminsSnapshot = await getDocs(collection(db, 'newadmins'));
          adminsSnapshot.forEach((d) => {
            const adminData = d.data();
            if (adminData.email === currentUserEmail.toLowerCase().trim()) {
              location = adminData.location || '';
              if (location) localStorage.setItem('adminLocation', location);
            }
          });
        }
      }

      // MUST have location if not superadmin
      if (!isSuperAdmin && (!location || !location.toString().trim())) {
        setErr("Lokatsiya topilmadi. Iltimos, qayta kirib ko'ring.");
        setLoading(false);
        return;
      }

      const searchTermLower = term.toLowerCase();
      const searchTerms = searchTermLower.split(/\s+/).filter(Boolean);
      
      let q;
      if (isSuperAdmin) {
        q = query(collection(db, "images"));
      } else {
        const locationStr = location.toString().trim();
        q = query(
          collection(db, "images"),
          where("location", "==", locationStr)
        );
      }
      
      const snap = await getDocs(q);

      const list = [];
      snap.forEach((d) => {
        const rowData = d.data();
        const userName = (rowData.name || '').toLowerCase();
        
        // Search algorithm: check if all words in search query are present in the user name
        const matches = searchTerms.every(word => userName.includes(word));
        
        if (matches) {
          list.push({ id: d.id, ...rowData });
        }
      });

      // Sort by uploadedAt desc client-side
      list.sort((a, b) => {
        const at = (a.uploadedAt?.toDate?.() ?? new Date(a.uploadedAt || 0)).getTime();
        const bt = (b.uploadedAt?.toDate?.() ?? new Date(b.uploadedAt || 0)).getTime();
        return bt - at;
      });

      setAllRows(list);
      setRows(list);
      setShowAllUsers(true);
      setCurrentPage(1);

      if (list.length === 0) {
        setErr(`"${term}" ismi bo'yicha foydalanuvchi topilmadi.`);
      }
    } catch (e) {
      console.error('Error searching user by name:', e);
      setErr("Qidiruvda xatolik yuz berdi. Iltimos, keyinroq qayta urinib ko'ring.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="wrap">
      <style>{styles}</style>

      {!hideHeader && (
      <div className="titleRow">
        <div>
          <h1 className="h1">To'lovlar boshqaruvi (images коллекция)</h1>
          <div className="sub">
            {loading ? "Yuklanmoqda..." : (
              showAllUsers 
                ? `Jami: ${rows.length} ta yozuv` 
                : (() => {
                    const totalPages = Math.ceil(allRows.length / itemsPerPage);
                    return `Sahifa: ${currentPage}/${totalPages} | Ko'rsatilmoqda: ${rows.length} ta (Jami: ${allRows.length} ta)`;
                  })()
            )}
            {err ? ` — ${err}` : ""}
          </div>
          {(() => {
            const location = adminLocation || localStorage.getItem('adminLocation');
            const isSuperAdmin = userRole === 'superadmin' || localStorage.getItem('userRole') === 'superadmin';
            if (isSuperAdmin) {
              return (
                <div style={{ marginTop: '8px', padding: '6px 12px', background: 'rgba(241, 196, 15,.15)', border: '1px solid rgba(241, 196, 15,.35)', borderRadius: '6px', fontSize: '12px', display: 'inline-block' }}>
                  👑 Super Admin - Barcha lokatsiyalardagi yozuvlar ko'rsatilmoqda
                </div>
              );
            } else if (location) {
              return (
                <div style={{ marginTop: '8px', padding: '6px 12px', background: 'rgba(46, 204, 113,.15)', border: '1px solid rgba(46, 204, 113,.35)', borderRadius: '6px', fontSize: '12px', display: 'inline-block' }}>
                  📍 Lokatsiya filtri: <strong>{location}</strong> - Faqat bu lokatsiyadagi yozuvlar ko'rsatilmoqda
                </div>
              );
            }
            return null;
          })()}
        </div>

        <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
            <input
              type="text"
              placeholder="Ism bo'yicha qidirish"
              value={searchName}
              onChange={(e) => setSearchName(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  handleSearchByName();
                }
              }}
              style={{
                padding: '8px 10px',
                borderRadius: '8px',
                border: '1px solid rgba(148, 163, 184, 0.7)',
                background: '#020617',
                color: '#e6edf3',
                fontSize: '12px',
                minWidth: '150px',
              }}
              disabled={loading}
            />
            <button
              className="btn btnBlue"
              style={{ width: 90, padding: '8px 10px' }}
              onClick={handleSearchByName}
              disabled={loading}
            >
              Qidirish
            </button>
          </div>
          <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
            <input
              type="text"
              placeholder="Pasport ID bo'yicha qidirish"
              value={searchPassportId}
              onChange={(e) => setSearchPassportId(e.target.value.toUpperCase())}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  handleSearchByPassport();
                }
              }}
              style={{
                padding: '8px 10px',
                borderRadius: '8px',
                border: '1px solid rgba(148, 163, 184, 0.7)',
                background: '#020617',
                color: '#e6edf3',
                fontSize: '12px',
                minWidth: '150px',
              }}
              disabled={loading}
            />
            <button
              className="btn btnBlue"
              style={{ width: 90, padding: '8px 10px' }}
              onClick={handleSearchByPassport}
              disabled={loading}
            >
              Qidirish
            </button>
          </div>
          <button 
            className="btn btnGreen" 
            style={{ width: 160 }} 
            onClick={() => openModal("createUser", null)}
            disabled={loading}
          >
            + Yangi foydalanuvchi
          </button>
          {!showAllUsers && allRows.length > itemsPerPage && (
            <>
              <button 
                className="btn btnBlue" 
                style={{ width: 50, padding: '10px 8px' }} 
                onClick={prevPage}
                disabled={loading || currentPage === 1}
                title="Oldingi sahifa"
              >
                ‹
              </button>
              <button 
                className="btn btnBlue" 
                style={{ width: 50, padding: '10px 8px' }} 
                onClick={nextPage}
                disabled={loading || currentPage >= Math.ceil(allRows.length / itemsPerPage)}
                title="Keyingi sahifa"
              >
                ›
              </button>
            </>
          )}
          {showAllUsers && (
            <button 
              className="btn btnGray" 
              style={{ width: 160 }} 
              onClick={() => fetchRows(false)}
              disabled={loading}
              title="Faqat oxirgi 10 ta foydalanuvchini ko'rsatish"
            >
              🔼 Faqat 10 ta
            </button>
          )}
          <button className="btn btnGray" style={{ width: 140 }} onClick={() => fetchRows(false)} disabled={loading}>
            Yangilash
          </button>
          {onLogout && (
            <button 
              className="btn btnGray" 
              style={{ width: 120, background: '#dc2626' }} 
              onClick={onLogout}
            >
              Chiqish
            </button>
          )}
        </div>
      </div>
      )}

      <div className="panel">
        <table className="table">
          <thead>
            <tr>
              <th onClick={() => toggleSort("name")}>ISM</th>
              <th onClick={() => toggleSort("phone")}>TEL</th>
              <th onClick={() => toggleSort("passportId")}>PASSPORT ID</th>
              <th>COMMENT</th>
              <th>RASM</th>
              <th>TUGATGANLIGI</th>
              <th>KURS NI TAMOMLAGAN</th>
              <th onClick={() => toggleSort("agreedAmount")}>KELISHILGAN SUMMA</th>
              <th onClick={() => toggleSort("agreedAmountForma083")}>KELISHILGAN SUMMA 083</th>
              <th onClick={() => toggleSort("uploadedAt")}>RO'YHATDAGI SANA</th>
              <th>KURS TO'LOV</th>
              <th>FORMA 083</th>
              <th>KURS TARIX</th>
              <th>083 TARIX</th>
              <th>QARZ (KURS)</th>
              <th>QOLDIQ (083)</th>
              {(userRole === 'superadmin' || localStorage.getItem('userRole') === 'superadmin') && (
                <th>O'CHIRISH</th>
              )}
            </tr>
          </thead>

          <tbody>
            {sorted.map((r) => {
              const kursAgreed = toNumberSafe(r.agreedAmount);
              const kursPaid = sumPayments(r.debtPayments);
              const kursRemain = kursAgreed - kursPaid;

              const f083Agreed =
                r.agreedAmountForma083 === null || r.agreedAmountForma083 === undefined
                  ? null
                  : toNumberSafe(r.agreedAmountForma083);

              const f083Paid = sumPayments(r.forma083Payments);
              const f083Remain = f083Agreed === null ? null : f083Agreed - f083Paid;

              return (
                <tr key={r.id}>
                  <td style={{ width: 160 }}>
                    <div style={{ fontWeight: 800 }}>{r.name || "—"}</div>
                    <div className="muted" style={{ fontSize: 11, marginTop: 6 }}>
                      {r.location ? `Manzil: ${r.location}` : ""}
                    </div>
                  </td>

                  <td style={{ width: 100 }}>{r.phone || "—"}</td>
                  <td style={{ width: 120 }}>{r.passportId || "—"}</td>

                  <td style={{ width: 170 }}>
                    {r.comment ? (
                      <div style={{ whiteSpace: 'pre-wrap', lineHeight: 1.4 }}>{r.comment}</div>
                    ) : (
                      <span className="muted">—</span>
                    )}
                  </td>

                  <td style={{ width: 80 }}>
                    {r.imageUrl ? (
                      <a href={r.imageUrl} target="_blank" rel="noreferrer">
                        <img className="imgThumb" src={r.imageUrl} alt="img" />
                      </a>
                    ) : (
                      <div className="muted">—</div>
                    )}
                  </td>

                  <td style={{ width: 120 }}>
                    {r.tugatganligi ? (
                      <span className="chip chipOk">Tugatgan</span>
                    ) : (
                      <span className="chip chipNo">Jarayonda</span>
                    )}
                  </td>

                  <td style={{ width: 150 }}>
                    {r.tugatganligi ? (
                      <div className="muted" style={{ fontSize: 11 }}>
                        Kurs tamomlangan
                      </div>
                    ) : (
                      <button
                        className="btn btnGreen"
                        style={{ margin: 0, padding: '8px 10px' }}
                        onClick={() => markKursCompleted(r)}
                        disabled={loading}
                      >
                        Kurs ni tamomlagan
                      </button>
                    )}
                  </td>

                  <td style={{ width: 140 }}>
                    <div className="money">{formatUZS(kursAgreed)}</div>
                    <div className="muted" style={{ fontSize: 11, marginTop: 6 }}>
                      To'langan: {formatUZS(kursPaid)}
                    </div>
                  </td>

                  <td style={{ width: 150 }}>
                    {f083Agreed === null ? (
                      <span className="chip">Belgilanmagan</span>
                    ) : (
                      <>
                        <div className="money">{formatUZS(f083Agreed)}</div>
                        <div className="muted" style={{ fontSize: 11, marginTop: 6 }}>
                          To'langan: {formatUZS(f083Paid)}
                        </div>
                      </>
                    )}
                  </td>

                  <td style={{ width: 160 }}>{formatDateMaybe(r.uploadedAt)}</td>

                  <td style={{ width: 150 }}>
                    {(!kursAgreed || kursAgreed <= 0) ? (
                      <>
                        <button className="btn btnOrange" onClick={() => openModal("kursSet", r)} disabled={loading}>
                          Kurs narx belgilash
                        </button>
                        <div className="muted" style={{ fontSize: 11 }}>Avval narx belgilanadi</div>
                      </>
                    ) : (
                      <>
                        <button
                          className="btn btnBlue"
                          onClick={() => openModal("kursPay", r)}
                          disabled={loading || kursRemain <= 0}
                          title={kursRemain <= 0 ? "Qarz qolmagan" : "To'lov kiritish"}
                        >
                          Kurs to'lov qilish
                        </button>
                        <div className="muted" style={{ fontSize: 11 }}>
                          Qoldiq:{" "}
                          <span className={kursRemain <= 0 ? "moneyGood" : "moneyWarn"}>
                            {formatUZS(Math.max(0, kursRemain))}
                          </span>
                        </div>
                      </>
                    )}
                  </td>

                  <td style={{ width: 160 }}>
                    {f083Agreed === null ? (
                      <>
                        <button className="btn btnOrange" onClick={() => openModal("forma083Set", r)} disabled={loading}>
                          083 narx belgilash
                        </button>
                        <div className="muted" style={{ fontSize: 11 }}>Avval narx belgilanadi</div>
                      </>
                    ) : (
                      <>
                        <button
                          className="btn btnGreen"
                          onClick={() => openModal("forma083Pay", r)}
                          disabled={loading || (f083Remain !== null && f083Remain <= 0)}
                        >
                          083 to'lov
                        </button>
                        <div className="muted" style={{ fontSize: 11 }}>
                          Qoldiq:{" "}
                          <span className={f083Remain <= 0 ? "moneyGood" : "moneyWarn"}>
                            {formatUZS(Math.max(0, f083Remain))}
                          </span>
                        </div>
                      </>
                    )}
                  </td>

                  <td style={{ width: 170 }}>
                    <div className="historyBox">
                      {(r.debtPayments || []).slice().reverse().map((p, idx) => (
                        <div className="historyItem" key={idx}>
                          <div className="money">{formatUZS(p.amount)}</div>
                          <div className="muted">{formatDateMaybe(p.timestamp)}</div>
                        </div>
                      ))}
                      {(!r.debtPayments || r.debtPayments.length === 0) && <div className="muted">To'lov yo'q</div>}
                    </div>
                  </td>

                  <td style={{ width: 170 }}>
                    <div className="historyBox">
                      {(r.forma083Payments || []).slice().reverse().map((p, idx) => (
                        <div className="historyItem" key={idx}>
                          <div className="money">{formatUZS(p.amount)}</div>
                          <div className="muted">{formatDateMaybe(p.timestamp)}</div>
                        </div>
                      ))}
                      {(!r.forma083Payments || r.forma083Payments.length === 0) && <div className="muted">To'lov yo'q</div>}
                    </div>
                  </td>

                  <td style={{ width: 120 }}>
                    <div className={`money ${kursRemain <= 0 ? "moneyGood" : "moneyBad"}`}>
                      {formatUZS(Math.max(0, kursRemain))}
                    </div>
                  </td>

                  <td style={{ width: 120 }}>
                    {f083Remain === null ? (
                      <div className="muted">—</div>
                    ) : (
                      <div className={`money ${f083Remain <= 0 ? "moneyGood" : "moneyBad"}`}>
                        {formatUZS(Math.max(0, f083Remain))}
                      </div>
                    )}
                  </td>
                  {(userRole === 'superadmin' || localStorage.getItem('userRole') === 'superadmin') && (
                    <td style={{ width: 100 }}>
                      <button
                        className="btn"
                        style={{ margin: 0, padding: '8px 10px', background: '#dc2626', color: 'white' }}
                        onClick={() => handleDeleteUser(r)}
                        disabled={loading}
                        title="Foydalanuvchini o'chirish"
                      >
                        O'chirish
                      </button>
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Modal */}
      {modal.open && (
        <div className="modalOverlay" onMouseDown={closeModal}>
          <div className="modal" onMouseDown={(e) => e.stopPropagation()}>
            {modal.type === "kursSet" && modal.row && (
              <>
                <h3 className="modalTitle">Kurs narx belgilash (faqat bir marta)</h3>

                <div className="grid2">
                  <div className="field">
                    <label>Ism</label>
                    <input value={modal.row.name || ""} disabled />
                  </div>
                  <div className="field">
                    <label>Passport</label>
                    <input value={modal.row.passportId || ""} disabled />
                  </div>
                </div>

                <div className="field">
                  <label>Kurs kelishilgan summa</label>
                  <input
                    placeholder="Masalan: 1500000"
                    value={amountInput}
                    onChange={(e) => setAmountInput(e.target.value)}
                  />
                </div>

                <div className="rowBtns">
                  <button className="btn btnOrange" style={{ margin: 0 }} onClick={saveKursPriceOnce} disabled={loading}>
                    Belgilash
                  </button>
                  <button className="btn btnGray" style={{ margin: 0 }} onClick={closeModal} disabled={loading}>
                    Bekor
                  </button>
                </div>

                <div className="smallNote">
                  Bu qiymat `agreedAmount` ga yoziladi. Keyin to'lovlar `debtPayments` ga qo'shiladi.
                </div>
              </>
            )}

            {modal.type === "kursPay" && modal.row && (
              <>
                <h3 className="modalTitle">Kurs to'lov kiritish</h3>

                <div className="grid2">
                  <div className="field">
                    <label>Ism</label>
                    <input value={modal.row.name || ""} disabled />
                  </div>
                  <div className="field">
                    <label>Kelishilgan summa</label>
                    <input value={formatUZS(modal.row.agreedAmount)} disabled />
                  </div>
                </div>

                <div className="field">
                  <label>To'lov miqdori</label>
                  <input
                    placeholder="Masalan: 100000"
                    value={amountInput}
                    onChange={(e) => setAmountInput(e.target.value)}
                  />
                </div>

                <div className="rowBtns">
                  <button className="btn btnBlue" style={{ margin: 0 }} onClick={() => addPayment("debtPayments")} disabled={loading}>
                    Saqlash
                  </button>
                  <button className="btn btnGray" style={{ margin: 0 }} onClick={closeModal} disabled={loading}>
                    Bekor
                  </button>
                </div>

                <div className="smallNote">
                  To'lov `debtPayments` massiviga `{`{ amount, timestamp }`}` ko'rinishida qo'shiladi.
                </div>
              </>
            )}

            {modal.type === "forma083Set" && modal.row && (
              <>
                <h3 className="modalTitle">083 narx belgilash (faqat bir marta)</h3>

                <div className="grid2">
                  <div className="field">
                    <label>Ism</label>
                    <input value={modal.row.name || ""} disabled />
                  </div>
                  <div className="field">
                    <label>Passport</label>
                    <input value={modal.row.passportId || ""} disabled />
                  </div>
                </div>

                <div className="field">
                  <label>083 kelishilgan summa</label>
                  <input
                    placeholder="Masalan: 150000"
                    value={amountInput}
                    onChange={(e) => setAmountInput(e.target.value)}
                  />
                </div>

                <div className="rowBtns">
                  <button className="btn btnOrange" style={{ margin: 0 }} onClick={saveForma083PriceOnce} disabled={loading}>
                    Belgilash
                  </button>
                  <button className="btn btnGray" style={{ margin: 0 }} onClick={closeModal} disabled={loading}>
                    Bekor
                  </button>
                </div>

                <div className="smallNote">
                  Bu qiymat `agreedAmountForma083` ga yoziladi. Keyin to'lovlar `forma083Payments` ga qo'shiladi.
                </div>
              </>
            )}

            {modal.type === "forma083Pay" && modal.row && (
              <>
                <h3 className="modalTitle">083 to'lov kiritish</h3>

                <div className="grid2">
                  <div className="field">
                    <label>Ism</label>
                    <input value={modal.row.name || ""} disabled />
                  </div>
                  <div className="field">
                    <label>083 kelishilgan summa</label>
                    <input value={formatUZS(modal.row.agreedAmountForma083)} disabled />
                  </div>
                </div>

                <div className="field">
                  <label>To'lov miqdori</label>
                  <input
                    placeholder="Masalan: 50000"
                    value={amountInput}
                    onChange={(e) => setAmountInput(e.target.value)}
                  />
                </div>

                <div className="rowBtns">
                  <button className="btn btnGreen" style={{ margin: 0 }} onClick={() => addPayment("forma083Payments")} disabled={loading}>
                    Saqlash
                  </button>
                  <button className="btn btnGray" style={{ margin: 0 }} onClick={closeModal} disabled={loading}>
                    Bekor
                  </button>
                </div>

                <div className="smallNote">
                  To'lov `forma083Payments` massiviga `{`{ amount, timestamp }`}` ko'rinishida qo'shiladi.
                </div>
              </>
            )}

            {modal.type === "createUser" && (
              <>
                <h3 className="modalTitle">Yangi foydalanuvchi yaratish</h3>

                <div className="field">
                  <label>Ism *</label>
                  <input
                    type="text"
                    placeholder="Masalan: ABBOSBEK SAMADOV"
                    value={newUserForm.name}
                    onChange={(e) => setNewUserForm({ ...newUserForm, name: e.target.value })}
                    disabled={loading}
                  />
                </div>

                <div className="field">
                  <label>Telefon raqami *</label>
                  <input
                    type="tel"
                    placeholder="Masalan: 915900830"
                    value={newUserForm.phone}
                    onChange={(e) => setNewUserForm({ ...newUserForm, phone: e.target.value })}
                    disabled={loading}
                  />
                </div>

                <div className="field">
                  <label>Pasport ID *</label>
                  <input
                    type="text"
                    placeholder="Masalan: AB7622101"
                    value={newUserForm.passportId}
                    onChange={(e) => setNewUserForm({ ...newUserForm, passportId: e.target.value.toUpperCase() })}
                    disabled={loading}
                    style={{ textTransform: 'uppercase' }}
                  />
                </div>

                <div className="field">
                  <label>Comment</label>
                  <textarea
                    rows={3}
                    placeholder="Foydalanuvchi haqida izoh yoki qo'shimcha ma'lumot..."
                    value={newUserForm.comment}
                    onChange={(e) => setNewUserForm({ ...newUserForm, comment: e.target.value })}
                    disabled={loading}
                    style={{
                      width: '100%',
                      borderRadius: '12px',
                      border: '1px solid rgba(255,255,255,.10)',
                      background: '#0b1220',
                      color: '#e6edf3',
                      padding: '12px 16px',
                      outline: 'none',
                      resize: 'vertical',
                      fontSize: '13px',
                      minHeight: '80px',
                    }}
                  />
                </div>

                <div className="field">
                  <label>Rasm</label>
                  <div className="fileInputWrapper">
                    <input
                      type="file"
                      id="photoUpload"
                      accept="image/*"
                      onChange={handleFileChange}
                      disabled={uploadingPhoto || loading}
                    />
                    <label 
                      htmlFor="photoUpload" 
                      className={`fileInputLabel ${(uploadingPhoto || loading) ? 'disabled' : ''}`}
                    >
                      {uploadingPhoto ? (
                        <>
                          <span className="fileInputIcon">⏳</span>
                          <span>Yuklanmoqda...</span>
                        </>
                      ) : newUserForm.photo ? (
                        <>
                          <span className="fileInputIcon">✅</span>
                          <span>Rasm yuklandi - Boshqa rasm tanlash</span>
                        </>
                      ) : (
                        <>
                          <span className="fileInputIcon">📷</span>
                          <span>Rasm tanlash yoki bu yerga sudrab tashlang</span>
                        </>
                      )}
                    </label>
                  </div>
                  {newUserForm.photo && !uploadingPhoto && (
                    <div style={{ marginTop: '12px', textAlign: 'center' }}>
                      <img 
                        src={newUserForm.photo} 
                        alt="Preview" 
                        style={{ 
                          width: '120px', 
                          height: '120px', 
                          objectFit: 'cover', 
                          borderRadius: '12px',
                          border: '2px solid rgba(37, 99, 235, 0.3)',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.3)'
                        }} 
                      />
                    </div>
                  )}
                </div>

                <div className="rowBtns">
                  <button className="btn btnGreen" style={{ margin: 0 }} onClick={createNewUser} disabled={loading}>
                    Yaratish
                  </button>
                  <button className="btn btnGray" style={{ margin: 0 }} onClick={closeModal} disabled={loading}>
                    Bekor
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
